import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { getEnvironment } from "./utils/environment.ts";
import "./global.css";

async function enableMocking(): Promise<void> {
  const { internal } = getEnvironment();

  if (!internal) return;
  if (localStorage.getItem("psmConfigEnableMSW") !== "true") return;

  try {
    const { worker } = await import("./mocks/msw/browser");
    await worker.start({ onUnhandledRequest: "bypass" });
  } catch (error) {
    console.warn("[MSW] Failed to start service worker", error);
  }
}

enableMocking().then(() => {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
